import React, { useState } from "react";
import { Select } from "antd";
import { Button } from "../../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import CustomParams from "./CustomParams";
import IntlMessages from "@util/IntlMessages";
import "./MobileWidgetSettings.less";

const { Option } = Select;

const MobileWidgetSettings = ({ value }) => {
   const dispatch = useDispatch();
   const [settings, setSettings] = useState({
      ...value
   });

   const handleChange = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
   };

   return (
      <form onSubmit={handleSubmit} className="mobile-widget-settings">
         <div className="widget-settings">
            <div className="widget-settings__inner">
               <label key="mobileView" className="widget-settings__inner__label">
                  <IntlMessages id="settings.mobileView" />:
                  <Select
                     onChange={handleChange("mobileView")}
                     style={{ width: 200 }}
                     defaultValue={value.mobileView}
                  >
                     <Option value="map_android_entire_route">
                        <IntlMessages id="android.entire_route" />
                     </Option>
                     <Option value="map_android_section_route">
                        <IntlMessages id="android.section_route" />
                     </Option>
                     <Option value="android_SRAP">
                        <IntlMessages id="android.SRAP" />
                     </Option>
                  </Select>
               </label>

               <CustomParams initialParams={value?.options} setSettings={setSettings} />
            </div>
            <Button buttonType="primary" htmlType="submit">
               <IntlMessages id="global.preview" />
            </Button>
         </div>
      </form>
   );
};

export default MobileWidgetSettings;
